import templateAdmin from '../../../../Template/config/components/adminView'
import adminConfigManager from './AdminConfigManager'

export default {
  ...templateAdmin,
  adminConfigManager

}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastSMBPremarket/config/components/adminView/index.js